import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Flex, Box, Button, Copy, Icon, Currency } from '@elparking/components'

import LoadingBlock from 'commons/js/ui/LoadingBlock'

const renderLinePrice = (price) => {
    return !price || (price.amount === 0)
    ? <FormattedMessage defaultMessage='Gratis' />
    : <Currency qty={price} />
}

const Breakdown = ({
    price,
    isLoading,
    promoCode,
    onDeletePromoCode,
}) => (
    <Box>
        {<Flex mb='8px' justifyContent='space-between' w='100%' alingItem='center'>
            <Copy padding='0' fontSize='small' fontWeight='regular'>
                <FormattedMessage defaultMessage='Dispositivo' />
            </Copy>
            <Copy padding='0' transform='uppercase' fontSize='small' fontWeight='medium'>
                {isLoading ? <LoadingBlock size='small' width='40px' /> : renderLinePrice(price.totalProductBasePrice)}
            </Copy>
        </Flex>}
        {<Flex mb='8px' justifyContent='space-between' w='100%' alingItem='center'>
            <Copy padding='0' fontSize='small' fontWeight='regular'>
                <FormattedMessage defaultMessage='Cuota' />
            </Copy>
            <Copy padding='0' transform='uppercase' fontSize='small' fontWeight='medium'>
                { isLoading ? <LoadingBlock size='small' width='40px' /> : renderLinePrice(price.totalQuotaBasePrice)}
            </Copy>
        </Flex>}
        {<Flex mb='8px' justifyContent='space-between' w='100%' alingItem='center'>
            <Copy padding='0' fontSize='small' fontWeight='regular'>
                <FormattedMessage defaultMessage='Envío' />
            </Copy>
            <Copy padding='0' transform='uppercase' fontSize='small' fontWeight='medium'>
                {isLoading ? <LoadingBlock size='small' width='30px' /> : renderLinePrice(price.totalShippingBasePrice)}
            </Copy>
        </Flex>}
        {price.promoCodeDiscountedPrice && <Flex mb='8px' justifyContent='space-between' w='100%' alingItem='center'>
            <Box>
                <Copy padding='0' fontSize='small' fontWeight='regular'>
                    <FormattedMessage defaultMessage='Código promocional' />
                </Copy>
                <Copy padding='0' transform='uppercase' fontSize='small' fontWeight='medium' color='main'>
                    { promoCode.code } {onDeletePromoCode && <Button.unstyled onClick={onDeletePromoCode} padding='0'><Icon type='x' /></Button.unstyled>}
                </Copy>
            </Box>
            <Copy padding='0' transform='uppercase' fontSize='small' fontWeight='medium'>
                {isLoading ? <LoadingBlock size='small' width='30px' /> : renderLinePrice(price.promoCodeDiscountedPrice)}
            </Copy>
        </Flex>}
        <Flex justifyContent='space-between' w='100%' alingItem='center'>
            <Copy padding='0' fontSize='small' fontWeight='regular'>
                <FormattedMessage defaultMessage='IVA' />
            </Copy>
            <Copy padding='0' transform='uppercase' fontSize='small' fontWeight='medium'>
                {isLoading ? <LoadingBlock size='small' width='30px' /> : renderLinePrice(price.taxQty)}
            </Copy>
        </Flex>
    </Box>
)

Breakdown.defaultProps = {
    onDeletePromoCode: null,
    isLoading: false,
}

Breakdown.propTypes = {
    onDeletePromoCode: PropTypes.func,
    isLoading: PropTypes.bool.isRequired,
    promoCode: PropTypes.shape({
        code: PropTypes.string,
    }),
    price: PropTypes.shape({
        taxQty: PropTypes.shape({
            amount: PropTypes.number,
            currency: PropTypes.string,
        }).isRequired,
        totalQuotaBasePrice: PropTypes.shape({
            amount: PropTypes.number,
            currency: PropTypes.string,
        }),
        totalShippingBasePrice: PropTypes.shape({
            amount: PropTypes.number,
            currency: PropTypes.string,
        }),
        totalProductBasePrice: PropTypes.shape({
            amount: PropTypes.number,
            currency: PropTypes.string,
        }),
        promoCodeDiscountedPrice: PropTypes.shape({
            amount: PropTypes.number,
            currency: PropTypes.string,
        }),
    }),
}

export default Breakdown
